module.exports = __webpack_public_path__ + "images/emoji/pouch.2573774ab9f1c9a2c182.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/pouch.png
// module id = F/pc
// module chunks = 1